import {Component, Input} from '@angular/core';
import {MenuService} from "../../../services/menu-service";

@Component({
    selector: 'app-active-page',
    templateUrl: './active-page.component.html',
    styleUrl: './active-page.component.css',
    standalone: false
})
export class ActivePageComponent {
  @Input() menuName: string = '';

  constructor(private menuService: MenuService) {}

  isActivePage(menuName: string): boolean {
    return this.menuService.GetActiveMenuName() === menuName;
  }

}
